import React from 'react';
import MsBI from "@/assets/images/hosting/synology-nas-story-apr25-featured.webp";

const HeroValueSection: React.FC = () => {
    return (
        <div className='container pt-12 md:pt-16 lg:pt-24 px-4 md:px-6 lg:px-8'>
            {/* Header Section */}
            <div className="text-center mb-12 md:mb-16 lg:mb-20 relative">
                <span className="inline-flex items-center gap-2 px-4 py-2 mb-6 bg-white/5 rounded-full border border-white/10 backdrop-blur-sm text-xs md:text-sm font-semibold text-gray-300 tracking-wider uppercase">
                    Data Infrastructure
                </span>

                <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight mb-4 md:mb-6">
                    Own Your Storage Control Your Costs
                </h2>
                <p className="text-base md:text-lg text-gray-300 max-w-4xl mx-auto leading-relaxed px-2 md:px-0">
                    Stop renting cloud storage month after month. Synology NAS delivers enterprise-grade infrastructure you own—zero subscription fees, infinite scalability, complete data sovereignty.
                </p>
            </div>

            {/* Value Proposition Section */}
            <div className="h-full rounded-2xl bg-gradient-to-br from-purple-600/5 to-blue-600/5 border border-purple-500/20 p-6 md:py-8 md:px-10 hover:border-purple-500/50 hover:bg-gradient-to-br hover:from-purple-600/10 hover:to-blue-600/10 transition-all duration-300 mb-16 md:mb-20 lg:mb-24 relative overflow-hidden">
                <div
                    className="absolute inset-0 pointer-events-none"
                    style={{ background: 'radial-gradient(circle at 30% 50%, rgba(147, 51, 234, 0.08) 0%, transparent 60%)' }}
                />

                <div className="relative z-10">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10 lg:gap-12 items-center">
                        <div>
                            <h3 className="text-xl md:text-2xl lg:text-3xl font-bold mb-5 md:mb-7 lg:mb-8">
                                Why Organizations Choose Synology Over Cloud Storage
                            </h3>
                            <p className="text-slate-300 leading-relaxed mb-4 md:mb-5">
                                While cloud services like OneDrive, Dropbox, and Google Drive lock you into perpetual subscriptions, Synology NAS is a one-time investment that pays for itself in under 18 months—then continues delivering value for years.
                            </p>

                            <p className="text-slate-300 leading-relaxed">
                                Beyond cost savings, you gain complete control over your data, eliminate bandwidth throttling, ensure regulatory compliance, and scale storage without permission or overage fees.
                            </p>
                        </div>

                        <div>
                            <img
                                src={MsBI}
                                alt='Synology NAS'
                                className="w-full h-48 md:h-56 lg:h-64 object-cover rounded-xl mb-4 md:mb-6"
                            />

                            <div className="bg-gradient-to-r from-purple-600/10 to-blue-600/10 border-l-4 border-purple-600 pl-4 md:pl-6 pr-4 md:pr-6 py-4 md:py-5 rounded-lg">
                                <strong className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-purple-400 to-blue-500 bg-clip-text text-transparent font-mono">
                                    $29,000+
                                </strong>
                                <p className="text-sm text-slate-400 mt-1">
                                    Average 5-year savings vs. cloud subscriptions
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeroValueSection;